<template>
  <div class="container old-globals">
    <cases-data-view-container @load="goToCase" @newCase="newCase()" />
  </div>
</template>

<script>
import CasesDataViewContainer from '../containers/CasesDataView';

export default {
  name: 'cases-screen',
  components: {
    CasesDataViewContainer,
  },
  props: {
    user: {
      type: Object,
      required: true,
    },
  },
  computed: {
    canCreateCase() {
      return true;
    },
  },
  methods: {
    goToCase(id) {
      this.$router.push({ name: 'case-editor', params: { id } });
    },
    newCase() {
      this.$router.push({ name: 'case-editor', params: { id: 'new' } });
    },
  },
};
</script>

<style scoped>
.container {
  height: 100%;
}

.new-case-button {
  position: fixed;
  bottom: 20px;
  right: 20px;
}
</style>
